<script setup lang="ts">
withDefaults(
  defineProps<{
    isActive?: boolean
  }>(),
  {
    isActive: false,
  },
)
</script>

<template>
  <div
    class="flex size-[40px] cursor-pointer items-center justify-center rounded-full bg-gray-700/50"
  >
    <BaseIcon
      name="heart"
      :class="[
        'stroke-white hover:fill-gray-300 hover:stroke-gray-300',
        { 'fill-white': isActive },
      ]"
    />
  </div>
</template>
